<template>
    <div class="message" v-if="isShow">
        <div v-html="message"></div>
    </div>
</template>

<script>
export default {
    props:{
        message:{
            type:String,
            require:true
        },
        duration:{
            type:Number,
            default:1.5,
        }
    },
    data(){
        return {
            isShow:false,
        }
    },
    created(){
        this.show();
    },
    methods:{
        show(){
            this.isShow=true;
            setTimeout(()=>{
                this.isShow=false;
            },this.duration*1000);
        },
        close(){
            this.isShow=false;
        }
    }
}
</script>
<style lang="less" scoped>

.message{
    position: fixed;
    z-index: 1001;
    top:30%;
    width: 100%;
    div {
        text-align: center;
        // max-width: 60%;
        line-height: 20px;
        display: table;
        box-sizing: border-box;
        background-color: rgba(0,0,0,0.5);
        color:rgb(255, 255, 255);
        padding: 12px;
        padding-left: 24px;
        padding-right: 24px;
        font-size: 12px;
        border-radius: 5px;
        text-align: center;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/message/tip.vue